var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-maxbox"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-max"},[_vm._v("我们的服务 "),_c('span',{staticClass:"title-min"},[_vm._v("Our Services")])])]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":"https://ym-attached-file.oss-cn-shanghai.aliyuncs.com/pcProject/ourServices.png"}})])])
}]

export { render, staticRenderFns }